import { Button, Typography } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

const HelpText = styled(Typography)`
  ${Button.S.Button} {
    display: inline;
  }
`;

const Video = styled.div`
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  width: 100%;

  .video-react {
    height: 300px;
    max-height: 300px;
  }
`;

const VideoContainer = styled.div`
  align-items: center;
  background: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-16);
  padding: var(--size-padding-16);
`;

const SwiperContainer = styled.div`
  width: 100%;

  .swiper {
    height: 100%;
    width: 100%;
  }
`;

const SlideContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  gap: 40px;
  padding: 0 48px;
  width: 100%;
`;

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  max-width: 352px;
  min-width: 352px;
`;

const RightContent = styled.div`
  width: 100%;
`;

const Pagination = styled.div`
  display: flex;
  gap: 4px;
`;

const Bullet = styled.div`
  border-radius: 100%;
  height: 8px;
  opacity: 0.4;
  width: 8px;

  ${({ active }) => {
    return css`
      background: var(${active ? '--color-fg-weakest' : '--color-fg-weakest2'});
    `;
  }}
`;

const LeftContentBody = styled.div`
  display: flex;
  gap: 16px;
`;

const LeftContentBodyNumber = styled.div`
  align-items: center;
  background-color: var(--color-accent-primary-default);
  border-radius: 24px;
  color: var(--color-fg-inverse-default);
  display: flex;
  font-size: 28px;
  font-weight: 600;
  height: 48px;
  justify-content: center;
  min-width: 48px;
`;

const LeftContentBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export {
  Bullet,
  HelpText,
  LeftContent,
  LeftContentBody,
  LeftContentBodyContent,
  LeftContentBodyNumber,
  Pagination,
  RightContent,
  SlideContainer,
  SwiperContainer,
  Video,
  VideoContainer
};
